import type { DashboardStats } from '../../types'
import { formatCurrency } from '../../lib/formatters'

interface QuickStatsProps {
  stats: DashboardStats
}

export function QuickStats({ stats }: QuickStatsProps) {

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-swiss-gray-200 border border-swiss-gray-200">
      {/* Total Portfolio Value */}
      <div className="bg-swiss-white p-6">
        <div className="text-swiss-label uppercase tracking-widest text-swiss-gray-500 mb-2">
          Portfolio Value
        </div>
        <div className="font-swiss-mono text-swiss-h1 font-semibold">
          {formatCurrency(stats.totalPortfolioValue)}
        </div>
      </div>

      {/* Transactions Today */}
      <div className="bg-swiss-white p-6">
        <div className="text-swiss-label uppercase tracking-widest text-swiss-gray-500 mb-2">
          Today
        </div>
        <div className="font-swiss-mono text-swiss-h1 font-semibold">
          {stats.transactionsToday}
        </div>
        <div className="text-swiss-caption text-swiss-gray-500 mt-1">
          transactions
        </div>
      </div>

      {/* Transactions This Week */}
      <div className="bg-swiss-white p-6">
        <div className="text-swiss-label uppercase tracking-widest text-swiss-gray-500 mb-2">
          This Week
        </div>
        <div className="font-swiss-mono text-swiss-h1 font-semibold">
          {stats.transactionsThisWeek}
        </div>
        <div className="text-swiss-caption text-swiss-gray-500 mt-1">
          transactions
        </div>
      </div>

      {/* Pending Reviews */}
      <div className="bg-swiss-white p-6">
        <div className="text-swiss-label uppercase tracking-widest text-swiss-gray-500 mb-2">
          Pending Review
        </div>
        <div
          className={`font-swiss-mono text-swiss-h1 font-semibold ${
            stats.pendingReviews > 0 ? 'text-swiss-red' : ''
          }`}
        >
          {stats.pendingReviews}
        </div>
        <div className="text-swiss-caption text-swiss-gray-500 mt-1">
          classifications
        </div>
      </div>
    </div>
  )
}
